import { useMemo } from "react";
import Navbar from "./Navbar";
import Footer from "./Footer";

const MainContent = ({ isLoginRoute, activeMenu, children }) => {
  const mainClass = useMemo(() => {
    return activeMenu && !isLoginRoute
      ? "dark:bg-main-dark-bg bg-main-bg min-h-screen md:ml-60 w-full overflow-hidden"
      : "bg-main-bg dark:bg-main-dark-bg w-full min-h-screen flex-2";
  }, [activeMenu, isLoginRoute]);
  return (
    <div className={mainClass}>
      {!isLoginRoute && (
        <div className="fixed md:static bg-main-bg dark:bg-main-dark-bg navbar w-full">
          <Navbar />
        </div>
      )}
      <div>
        {children}
      </div>
    </div>
  );
};
export default MainContent;
